import classNames from 'classnames';
import React from 'react';
import { useClearRefinements, useClearRefinementsProps } from 'react-instantsearch-hooks-web';

export const ClearRefinements = (props) => {
  const { canRefine, refine } = useClearRefinements(props);
  const buttonClasses = classNames('ais-ClearRefinements-button', {
    'ais-ClearRefinements-button--disabled': !canRefine,
  });
  return (
    <div class="ais-ClearRefinements">
      <button className={buttonClasses} disabled={!canRefine} onClick={() => refine()}>
        Clear Refinements
      </button>
    </div>
  );
};
